import React, { useState, useEffect } from "react";
import { storageLocaleKey } from "./types.js";
const LocaleContext = React.createContext({
  locale: void 0,
  isInitialized: false,
  handleLocaleChange: () => {
  }
});
function LocaleProvider({ children, defaultLocale }) {
  const [locale, setLocale] = useState(void 0);
  const [isLocaleInitialized, setIsLocaleInitialized] = useState(false);
  useEffect(() => {
    const storedLocale = localStorage.getItem(storageLocaleKey);
    if (storedLocale) {
      try {
        setLocale(JSON.parse(storedLocale));
      } catch {
        setLocale(storedLocale);
      }
    } else {
      handleLocaleChange(defaultLocale);
    }
    setIsLocaleInitialized(true);
  }, []);
  function handleLocaleChange(newLocale) {
    localStorage.setItem(storageLocaleKey, newLocale);
    setLocale(newLocale);
  }
  return /* @__PURE__ */ React.createElement(LocaleContext.Provider, { value: { locale, handleLocaleChange, isInitialized: isLocaleInitialized } }, children);
}
export {
  LocaleContext,
  LocaleProvider
};
//# sourceMappingURL=LocaleProvider.js.map
